/*
 * hx-mega-horizontal — drill toggle for the HyperX horizontal mega menu.
 *
 * Scope: ONLY the drill behaviour. The card carousel is a native <hdt-slider>
 * and needs no JS here.
 *
 * Behaviour:
 *   click a [data-hx-card] card  -> hide all panels, show its [data-hx-panel],
 *                                   mark the card is-active, dim the others,
 *                                   flag host is-panel-open.
 *   click the active card again  -> reset (collapse back to the carousel).
 *   dropdown closes (details)    -> reset.
 */
(function () {
  if (customElements.get('hx-mega-horizontal')) return;

  class HxMegaHorizontal extends HTMLElement {
    connectedCallback() {
      this._onClick = this._onClick.bind(this);
      this._onToggle = this._onToggle.bind(this);
      this.addEventListener('click', this._onClick);

      this._details = this.closest('details');
      if (this._details) this._details.addEventListener('toggle', this._onToggle);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      if (this._details) this._details.removeEventListener('toggle', this._onToggle);
    }

    _onToggle() {
      if (this._details && !this._details.open) this.reset();
    }

    _onClick(event) {
      const card = event.target.closest('[data-hx-card]');
      if (!card || !this.contains(card)) return;
      event.preventDefault();
      if (card.getAttribute('aria-expanded') === 'true') {
        this.reset();
      } else {
        this.activate(card.getAttribute('data-hx-card'));
      }
    }

    activate(index) {
      const panel = this.querySelector('[data-hx-panel="' + CSS.escape(index) + '"]');
      if (!panel) return this.reset();

      this.querySelectorAll('[data-hx-card]').forEach(function (c) {
        c.setAttribute('aria-expanded', c.getAttribute('data-hx-card') === index ? 'true' : 'false');
      });
      this.querySelectorAll('[data-hx-panel]').forEach(function (p) {
        p.toggleAttribute('hidden', p.getAttribute('data-hx-panel') !== index);
      });
      this.querySelectorAll('[data-hx-item]').forEach(function (item) {
        const active = item.getAttribute('data-hx-item') === index;
        item.classList.toggle('is-active', active);
        item.classList.toggle('is-dimmed', !active);
      });
      this.classList.add('is-panel-open');
    }

    reset() {
      this.querySelectorAll('[data-hx-card]').forEach(function (c) {
        c.setAttribute('aria-expanded', 'false');
      });
      this.querySelectorAll('[data-hx-panel]').forEach(function (p) {
        p.setAttribute('hidden', '');
      });
      this.querySelectorAll('[data-hx-item]').forEach(function (item) {
        item.classList.remove('is-active', 'is-dimmed');
      });
      this.classList.remove('is-panel-open');
    }
  }

  customElements.define('hx-mega-horizontal', HxMegaHorizontal);
})();
